module.exports = __webpack_public_path__ + "static/media/iconIsCheckBox.0d98c945.svg";